if($('.dropdown-expand').length) {
    $('.dropdown-expand').each(function () {

        let toggle = $(this).find('.dropdown-toggle-expand'),
            menu = $(this).find('.dropdown-menu-expand');

        toggle.on('click', function (e) {
            if($(this).hasClass('active')) {
                $(this).removeClass('active');
                menu.slideUp();
            } else {
                $(this).addClass('active');
                menu.slideDown();
            }
        });

    });
}
